module.exports = __webpack_public_path__ + "static/img/new2.99cf5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new2.png
// module id = BQ/O
// module chunks = 3